// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "20260923.1790200469/static/js/" + chunkId + "." + {"249":"1d705ebf","463":"8a875d0b"}[chunkId] + ".chunk.js";
};